export default (type: string, time?: Date) => {
  let startTime: any, endTime: any
  // 获取当前日期
  const today = time ? time : new Date()
  if (type === "year") {
    // 计算本年的开始日期
    const startOfYear = new Date(today.getFullYear(), 0, 1)
    // 将开始日期设置为当天的开始时间，即00:00:00
    startOfYear.setHours(0, 0, 0, 0)
    // 获取本年的开始时间戳（单位：毫秒）
    startTime = startOfYear.getTime()
    // 计算下一年的开始日期
    const nextYear = new Date(today.getFullYear() + 1, 0, 1)
    // 将下一年的开始日期减去1毫秒，得到本年的结束日期
    const endOfYear = new Date(nextYear.getTime() - 1)
    // 将结束日期设置为当天的结束时间，即23:59:59
    endOfYear.setHours(23, 59, 59, 999)
    // 获取本年的结束时间戳（单位：毫秒）
    endTime = endOfYear.getTime()
  } else if (type === "month") {
    // 计算本月的开始日期
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
    // 将开始日期设置为当天的开始时间，即00:00:00
    startOfMonth.setHours(0, 0, 0, 0)
    // 获取本月的开始时间戳（单位：毫秒）
    startTime = startOfMonth.getTime()
    // 计算下个月的开始日期
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)
    // 将下个月的开始日期减去1毫秒，得到本月的结束日期
    const endOfMonth = new Date(nextMonth.getTime() - 1)
    // 将结束日期设置为当天的结束时间，即23:59:59
    endOfMonth.setHours(23, 59, 59, 999)
    // 获取本月的结束时间戳（单位：毫秒）
    endTime = endOfMonth.getTime()
  } else if (type === "week") {
    // 获取当前日期是星期几（0表示周日，1表示周一，以此类推）
    const currentDayOfWeek = today.getDay()
    // 计算当前日期距离本周第一天（周日）的天数偏移量
    const offset = (currentDayOfWeek === 0 ? -6 : 1) - currentDayOfWeek
    // 计算本周的开始日期
    const startOfWeek = new Date(today)
    startOfWeek.setDate(today.getDate() + offset)
    // 将开始日期设置为当天的开始时间，即00:00:00
    startOfWeek.setHours(0, 0, 0, 0)
    // 获取本周的开始时间戳（单位：毫秒）
    startTime = startOfWeek.getTime()
    // 计算本周的结束日期
    const endOfWeek = new Date(startOfWeek)
    endOfWeek.setDate(startOfWeek.getDate() + 6) // 本周结束日期为开始日期加6天
    // 将结束日期设置为当天的结束时间，即23:59:59
    endOfWeek.setHours(23, 59, 59, 999)
    // 获取本周的结束时间戳（单位：毫秒）
    endTime = endOfWeek.getTime()
  } else if (type === "day") {
    // 将当前日期设置为今天的开始时间，即00:00:00
    today.setHours(0, 0, 0, 0)
    // 获取今天的开始时间戳（单位：毫秒）
    startTime = today.getTime()
    // 将当前日期设置为今天的结束时间，即23:59:59
    today.setHours(23, 59, 59, 999)
    // 获取今天的结束时间戳（单位：毫秒）
    endTime = today.getTime()
  } else {
    startTime = today.getTime() - 1000 * 60
    today.setHours(23, 59, 59, 999)
    endTime = today.getTime()
  }
  return { startTime, endTime }
}
